/**
 * Deployments that may show dev/QA affordances when they name themselves, as
 * spelled by the deployment workflows. A new deployment name belongs here.
 */
const NON_PRODUCTION_ENVIRONMENTS = ['development', 'staging'];

/**
 * Whether dev/QA affordances such as the payment simulator may render: opt-IN,
 * because an undeclared build is production and the old "hide when it says
 * production" test read that silence as development. Never a security boundary
 * — those endpoints answer 403 on production regardless.
 */
export const canShowDevAffordances = (): boolean =>
  process.env.NODE_ENV !== 'production' ||
  NON_PRODUCTION_ENVIRONMENTS.includes(
    (process.env.REACT_APP_ENVIRONMENT || '').toLowerCase()
  );
